import { Icon, Typography } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import i18n from "../../i18n/i18next";

export const OrgIsBeeingMade = () => {
  return (
    <Stack
      direction="column"
      sx={{
        height: "100%",
        justifyContent: "center",
        width: "100%",
        alignItems: "center"
      }}>
      <Typography
        variant="bodyBold"
        sx={{
          margin: "16px",
          textAlign: "center"
        }}>
        <div id="orgIsBeingCreatedText">{i18n.t("account.team-creating")}</div>
      </Typography>
      <Icon name="Loading" />
    </Stack>
  );
};
